export default "__VITE_ASSET__Db5gW8V1__"